import React from "react";
import { EPaletteModes } from "types/theme-packs";

type ThemeContextType = [EPaletteModes, (theme: EPaletteModes) => void];
const defaultContext = (): ThemeContextType => [EPaletteModes.Light, (_: EPaletteModes) => undefined];

export const ThemeContext = React.createContext<ThemeContextType>(defaultContext());
